import { render, staticRenderFns } from "./RecoveryForm.vue?vue&type=template&id=80585c0e&scoped=true"
import script from "./RecoveryForm.vue?vue&type=script&lang=js"
export * from "./RecoveryForm.vue?vue&type=script&lang=js"
import style0 from "./RecoveryForm.vue?vue&type=style&index=0&id=80585c0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80585c0e",
  null
  
)

export default component.exports